export default __webpack_public_path__ + "static/media/supper.43558e6c.svg";